import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { InputTextModule } from "primeng/inputtext";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { RadioButtonModule } from "primeng/radiobutton";
import { DecimalPipe, NgForOf, NgIf } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { PasswordModule } from "primeng/password";
import { Router } from "@angular/router";
import { ToastModule } from "primeng/toast";
import { FileUploadModule } from "primeng/fileupload";
import { MessageService } from "primeng/api";
import { EProductGroupType } from '../enums/EProductGroupType';
import { ProductOrderComponent } from '../product-order/product-order.component';
import { EventS } from '../service/event.s';
import { AuthService } from "../service/auth.service";
import { AddOrderService } from "../service/add-order.service";
import { ProductsService } from "../service/products.service";
import { DataProviderService } from "../service/data-provider.service";
import { environment } from "../../environments/environment";
import { NotificationService } from "../service/notification.service";
import { CheckboxModule } from "primeng/checkbox";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ProductGroupService } from "../service/product-group.service";
import * as _ from 'lodash';

declare const $: any;

type MaybeUploadPath = | string | { uploadPath?: string | null } | Array<string | { uploadPath?: string | null }>;

@Component({
    selector: 'app-add-order',
    standalone: true,
    imports: [ InputTextModule, ReactiveFormsModule, DropdownModule, RadioButtonModule, NgForOf, DialogModule, PasswordModule, ToastModule, FileUploadModule, NgIf, DecimalPipe, CheckboxModule, ProductOrderComponent, ProgressSpinnerModule, FormsModule ],
    templateUrl: './add-order.component.html',
    styleUrls: [ './add-order.component.scss' ],
    providers: [ MessageService ]
})
export class AddOrderComponent implements OnInit {
    visible: boolean = false;
    loading: boolean = false;
    addOrderForm: FormGroup | any;
    products: product[] = [];
    productGroups: any[] = [];
    productGroupsMap: { [_id: string]: any } = {};
    sizes: size[] = [];
    prints: print[] = [];
    foil: foil[] = [];
    spotUv: spotUv[] = [];
    quantity: qty[] = [];
    smallQuantity: qty[] = [];
    // uploadedFiles: any[] = [];
    description: any;
    productGroupId: string = '';
    taxValue: any;
    taxName: any;
    priceDetails: any[] = [];
    totalV: number | undefined;
    productGroup: string = "";
    productGroupCategory: string = "";
    productImages: any[] = [];
    // squareAndRegular: any[] = [];
    itemCount: number = 0;
    selectedProduct: product | undefined;
    showCdrModal: boolean = false;
    EProductGroupType = EProductGroupType;

    @ViewChild('productOrderComponent') productOrderComponents!: ProductOrderComponent;

    constructor(
        private fb: FormBuilder,
        private cd: ChangeDetectorRef,
        private ns: NotificationService,
        private authService: AuthService,
        private addOrderService: AddOrderService,
        private productsService: ProductsService,
        private productGroupService: ProductGroupService,
        private dataProviderService: DataProviderService,
        private router: Router,
        private eventCenterS: EventS
    ) {
        this.addOrderForm = this.fb.group({
            jobName: [ '' ],
            selectedProduct: [ '' ],
            selectedPrint: [ '' ],
            selectedQty: [ '', Validators.required ],
            width: [ '' ],
            height: [ '' ],
            foil: [ '' ],
            spotUv: [ '' ],
            price: [ '' ],
            // squareAndRegular: [''],
            totalPrice: [ '', ],
            selectedCategory: '',
        });
        this.addOrderForm.get('totalPrice')?.disable();
    }

    // async onUpload(event: any) {
    //     this.loading = true;
    //     for (let file of event.files) {
    //         if (this.isCdrFile(file)) {
    //             this.uploadedFiles.push(file);
    //             this.ns.showSuccess("File upload successfully.");
    //             await this.onSubmit();
    //             this.loading = false;
    //         } else {
    //             this.ns.showError(`Invalid File ${file.name} is not a .cdr file`);
    //             this.loading = false;
    //         }
    //     }
    // }

    onCartCountChange(count: number) {
        this.itemCount = count;
    }

    // isCdrFile(file: any): boolean {
    //     return file.name.toLowerCase().endsWith('.cdr');
    // }

    // async fileUpload(files: File[]) {
    //     if (files.length) {
    //         const formData = new FormData();
    //         formData.append('bucketName', environment.BUCKET_NAME);
    //         files.forEach((file: File) => formData.append('files', file));
    //         try {
    //             return await this.orderFileUploadService.fileUpload(formData);
    //         } catch (e: any) {
    //             this.ns.showError(`Invalid File`);
    //         }
    //     }
    // }

    async ngOnInit() {
        this.addOrderForm.get('selectedPrint').valueChanges.subscribe((data: string) => {
            if (!this.products.length) return;
            if (data?.toLowerCase().includes('single side')) {
                this.addOrderForm.get('totalPrice')?.setValue(this.selectedProduct?.mpp_productPrice_singleSide_num);
            } else if (data?.toLowerCase().includes('both side')) {
                this.addOrderForm.get('totalPrice')?.setValue(this.selectedProduct?.mpp_productPrice_bothSide_num);
            }
        });
        this.showCdrModal = true;
        this.addOrderForm.get('selectedProduct').valueChanges.subscribe((data: string) => {
            if (this.addOrderForm.get('selectedPrint').value) {
                let p = this.products.find((product: product) => {
                    return product._id === data;
                });
                if (this.addOrderForm.get('selectedPrint')?.value.toLowerCase() == 'single side') {
                    // console.log(this.selectedProduct);
                    this.addOrderForm.get('totalPrice')?.setValue(p?.mpp_productPrice_singleSide_num);
                } else if (this.addOrderForm.get('selectedPrint')?.value.toLowerCase().includes('both side')) {
                    this.addOrderForm.get('totalPrice')?.setValue(p?.mpp_productPrice_bothSide_num);
                }
            }
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (!this.dataProviderService.getDataForAddOrder().productGroupId) {
            await this.router.navigate([ '/product' ]);
        } else {
            let result = this.dataProviderService.getDataForAddOrder();
            // console.log(result);
            // this.description = result.description;
            this.productGroupId = result.productGroupId;
            this.taxName = result.taxName;
            this.taxValue = result.taxValue;
            this.productGroup = result.groupName;
            this.productGroupCategory = result.productGroupCategory;
        }

        let findObj = <any>{
            mpp_productGroup_objid: this.productGroupId,
            active: true
        };

        this.addOrderForm.get('selectedCategory')?.setValue(this.productGroupId);

        findObj.mpp_IsGstProduct_bl = !!this.authService.gUser.usr_gstNumber_str;

        this.products = await this.productsService.query({
            find: findObj
        });

        this.productGroups = await this.productGroupService.query({
            select: { mpg_productGroupName_str: 1, mpg_productGroupCategory_str: 1 }
        });
        this.productGroupsMap = _.keyBy(this.productGroups, '_id');

        this.sizes = [
            { name: 'Letter Size - 8.5"x11"', code: 'Letter Size - 8.5"x11"' }
        ];
        this.foil = [
            { name: 'Gold', code: 'Gold' },
            { name: 'Silver', code: 'Silver' }
        ];
        this.spotUv = [
            { name: 'Single Side', code: 'Single Side' },
            { name: 'Both Side', code: 'Both Side' }
        ];
        this.prints = [
            { name: 'Single Side', code: 'Single Side' },
            { name: 'Both Side', code: 'Both Side' }
        ];
        // this.squareAndRegular = [
        //     { name: 'Square', code: 'Square' },
        //     { name: 'Regular', code: 'Regular' }
        // ];

        if (this.productGroupCategory === EProductGroupType.STICKER_PER_SQ_INCH) {
            this.prints = [
                { name: 'Single Side', code: 'Single Side' },
                { name: 'Both Side', code: 'Both Side' }
            ];

            // Set default selected value in the form control
            this.addOrderForm.get('selectedPrint')?.setValue('Single Side');
        }
        this.quantity = [
            { name: '1000', code: '1000' },
            { name: '2000', code: '2000' },
            { name: '3000', code: '3000' },
            { name: '4000', code: '4000' },
            { name: '5000', code: '5000' },
            { name: '6000', code: '6000' },
            { name: '7000', code: '7000' },
            { name: '8000', code: '8000' },
            { name: '9000', code: '9000' },
            { name: '10000', code: '10000' },
            { name: '11000', code: '11000' },
            { name: '12000', code: '12000' },
            { name: '13000', code: '13000' },
            { name: '14000', code: '14000' },
            { name: '15000', code: '15000' },
            { name: '16000', code: '16000' },
            { name: '17000', code: '17000' },
            { name: '18000', code: '18000' },
            { name: '19000', code: '19000' },
            { name: '20000', code: '20000' },
            { name: '21000', code: '21000' },
            { name: '22000', code: '22000' },
            { name: '23000', code: '23000' },
            { name: '24000', code: '24000' },
            { name: '25000', code: '25000' },
            { name: '26000', code: '26000' },
            { name: '27000', code: '27000' },
            { name: '28000', code: '28000' },
            { name: '29000', code: '29000' },
            { name: '30000', code: '30000' },
            { name: '31000', code: '31000' },
            { name: '32000', code: '32000' },
            { name: '33000', code: '33000' },
            { name: '34000', code: '34000' },
            { name: '35000', code: '35000' },
            { name: '36000', code: '36000' },
            { name: '37000', code: '37000' },
            { name: '38000', code: '38000' },
            { name: '39000', code: '39000' },
            { name: '40000', code: '40000' },
            { name: '41000', code: '41000' },
            { name: '42000', code: '42000' },
            { name: '43000', code: '43000' },
            { name: '44000', code: '44000' },
            { name: '45000', code: '45000' },
            { name: '46000', code: '46000' },
            { name: '47000', code: '47000' },
            { name: '48000', code: '48000' },
            { name: '49000', code: '49000' },
            { name: '50000', code: '50000' }
        ];

        this.smallQuantity = [
            { name: '500', code: '500' },
            { name: '1000', code: '1000' },
            { name: '1500', code: '1500' },
            { name: '2000', code: '2000' },
            { name: '2500', code: '2500' },
            { name: '3000', code: '3000' },
            { name: '3500', code: '3500' },
            { name: '4000', code: '4000' },
            { name: '4500', code: '4500' },
            { name: '5000', code: '5000' },
            { name: '5500', code: '5500' },
            { name: '6000', code: '6000' },
            { name: '6500', code: '6500' },
            { name: '7000', code: '7000' },
            { name: '7500', code: '7500' },
            { name: '8000', code: '8000' },
            { name: '8500', code: '8500' },
            { name: '9000', code: '9000' },
            { name: '9500', code: '9500' },
            { name: '10000', code: '10000' },
            { name: '10500', code: '10500' },
            { name: '11000', code: '11000' },
            { name: '11500', code: '11500' },
            { name: '12000', code: '12000' },
            { name: '12500', code: '12500' },
            { name: '13000', code: '13000' },
            { name: '13500', code: '13500' },
            { name: '14000', code: '14000' },
            { name: '14500', code: '14500' },
            { name: '15000', code: '15000' },
            { name: '15500', code: '15500' },
            { name: '16000', code: '16000' },
            { name: '16500', code: '16500' },
            { name: '17000', code: '17000' },
            { name: '17500', code: '17500' },
            { name: '18000', code: '18000' },
            { name: '18500', code: '18500' },
            { name: '19000', code: '19000' },
            { name: '19500', code: '19500' },
            { name: '20000', code: '20000' },
            { name: '20500', code: '20500' },
            { name: '21000', code: '21000' },
            { name: '21500', code: '21500' },
            { name: '22000', code: '22000' },
            { name: '22500', code: '22500' },
            { name: '23000', code: '23000' },
            { name: '23500', code: '23500' },
            { name: '24000', code: '24000' },
            { name: '24500', code: '24500' },
            { name: '25000', code: '25000' }
        ];

        // Initialize Owl Carousel
        // this.initiateOwnCarousel();
        this.setValidation();
        this.cd.detectChanges();
    }

    // showDialog() {
    //     this.visible = true;
    // }

    initiateOwlCarousel() {
        $('#owl-carousel-1').owlCarousel({
            loop: true,
            nav: false,
            margin: 10,
            autoplay: true,
            autoplayTimeout: 4000,
            slideTransition: 'linear',
            autoplayHoverPause: false,
            dots: false,
            responsiveClass: true,
            responsive: {
                0: { items: 1.5 },
                600: { items: 2.5 },
                999: { items: 2.5 },
                1030: { items: 1.5 },
                1130: { items: 1.5 },
                1280: { items: 1.5 },
                1400: { items: 2.5 },
                1700: { items: 2.5 },
                1920: { items: 2.5 }
            }
        });
    }

    destroyOwlCarousel() {
        const $carousel = $('#owl-carousel-1');
        if ($carousel.hasClass('owl-loaded')) {
            $carousel.trigger('destroy.owl.carousel');
            $carousel.removeClass('owl-carousel owl-loaded');
            $carousel.find('.owl-stage-outer').children().unwrap();
        }
    }

    refreshOwlCarousel() {
        const $carousel = $('#owl-carousel-1');
        $carousel.addClass('owl-carousel');
    }

    async deleteOrder(order: any) {
        try {
            let res = await this.addOrderService.permanentDelete(order._id);
            if (res) {
                this.priceDetails = this.priceDetails.filter((order: any) => {
                    return order._id != res?._id;
                });
                this.ns.showSuccess(`Item remove successfully.`);
                this.eventCenterS.loadAddToCard.next(true);
            }
        } catch (e: any) {
            this.ns.showError(`Unable to remove order`);
        }
    }

    pickUploadPath(input: MaybeUploadPath): string {
        // If it's an array, use first entry
        if (Array.isArray(input)) {
            const first = input[0] as any;
            return this.pickUploadPath(first as MaybeUploadPath);
        }
        // If it's an object with uploadPath
        if (input && typeof input === 'object') {
            const maybe = (input as any).uploadPath;
            return typeof maybe === 'string' ? maybe : '';
        }
        // If it's a string already (direct path)
        if (typeof input === 'string') return input;
        return '';
    }

    async changeProducts() {
        this.resetForm();
        this.destroyOwlCarousel();
        this.productImages = [];
        this.description = '';
        let selectedCategories: product | undefined = this.products.find((element: product) => {
            return element._id == this.addOrderForm.get('selectedCategory')?.value;
        });
        selectedCategories?.mpp_productGroupImg_arr.forEach((item: any) => {
            let path = environment.FILE_URL + this.pickUploadPath(item);
            this.productImages.push(path);
        });
        let findObj = <any>{ mpp_productGroup_objid: this.addOrderForm.get('selectedCategory')?.value, active: true };

        if (this.authService.gUser.usr_gstNumber_str) {
            findObj.mpp_IsGstProduct_bl = true;
        } else {
            findObj.$or = [ {
                mpp_IsGstProduct_bl: <any>{
                    $exists: false,
                }
            }, {
                mpp_IsGstProduct_bl: <any>{
                    $in: [ null, '' ]
                }
            }, {
                mpp_IsGstProduct_bl: false
            } ];
        }
        this.products = await this.productsService.query({ find: findObj });

        // let selectedProductGroup = this.productGroupsMap[this.addOrderForm.get('selectedCategory')?.value];
        // this.dataProviderService.productGroupId = selectedProductGroup._id;

        this.productGroup = this.productGroupsMap[this.addOrderForm.get('selectedCategory')?.value]?.mpg_productGroupName_str;
        this.productGroupCategory = this.productGroupsMap[this.addOrderForm.get('selectedCategory')?.value]?.mpg_productGroupCategory_str;
        if (this.productGroupCategory === EProductGroupType.STICKER_PER_SQ_INCH) {
            this.addOrderForm.get('selectedPrint')?.patchValue('Single Side');
        }
        this.productGroupId = this.addOrderForm.get('selectedCategory')?.value;
        this.dataProviderService.productGroupId = this.productGroupId;
        this.setValidation();
        this.cd.detectChanges();
    }

    setValidation() {
        if (this.productGroupCategory === EProductGroupType.SPECIAL_JOB) {
            this.addOrderForm.get('selectedProduct')?.setValidators([]);
            this.addOrderForm.get('selectedProduct')?.updateValueAndValidity();
            this.addOrderForm.get('price')?.setValidators([ Validators.required ]);
            this.addOrderForm.get('price')?.updateValueAndValidity();

        } else {
            this.addOrderForm.get('selectedProduct')?.setValidators([ Validators.required ]);
            this.addOrderForm.get('selectedProduct')?.updateValueAndValidity();
            this.addOrderForm.get('price')?.setValidators([]);
            this.addOrderForm.get('price')?.updateValueAndValidity();
        }
    }

    resetForm() {
        this.addOrderForm.get('selectedProduct').setValue(null);
        this.addOrderForm.get('jobName').setValue(null);
        this.addOrderForm.get('selectedPrint').setValue(null);
        this.addOrderForm.get('selectedQty').setValue(null);
        this.addOrderForm.get('width').setValue(null);
        this.addOrderForm.get('height').setValue(null);
        this.addOrderForm.get('foil').setValue(null);
        this.addOrderForm.get('spotUv').setValue(null);
        this.addOrderForm.get('price').setValue(null);
        // this.addOrderForm.get('squareAndRegular').setValue(null);
        this.addOrderForm.get('totalPrice').setValue(null);
    }

    async renderImagesAndDesc() {
        this.addOrderForm.get('selectedPrint')?.setValue(null);
        this.addOrderForm.get('height')?.setValue(null);
        this.addOrderForm.get('width')?.setValue(null);
        this.destroyOwlCarousel();
        this.productImages = [];
        let selectedProduct: product = <any>this.products.find((element: product) => {
            return element._id == this.addOrderForm.get('selectedProduct')?.value;
        });
        selectedProduct?.mpp_productGroupImg_arr.forEach((item: any) => {
            let path = environment.FILE_URL + this.pickUploadPath(item);
            this.productImages.push(path);
        });
        this.description = selectedProduct?.mpp_description_str;

        this.selectedProduct = selectedProduct;
        if (this.selectedProduct.mpp_productPrice_bothSide_num <= 0) {
            this.prints = [
                { name: 'Single Side', code: 'Single Side' },
            ];
            this.addOrderForm.get('selectedPrint')?.setValue(this.prints[0].code);
        } else {
            this.prints = [
                { name: 'Single Side', code: 'Single Side' },
                { name: 'Both Side', code: 'Both Side' }
            ];
        }
        if (this.selectedProduct.mpp_IsheightWidth_bl) {
            this.addOrderForm.get('height').enable();
            this.addOrderForm.get('width').enable();
        } else {
            this.addOrderForm.get('height').disable();
            this.addOrderForm.get('width').disable();
        }

        this.cd.detectChanges();

        this.refreshOwlCarousel();

        setTimeout(() => {
            this.initiateOwlCarousel();
        }, 100);
        this.refreshOwlCarousel();
        // this.addOrderForm.get('totalPrice')?.setValue(selectedProduct.mpp_productPrice_num);
    }

    onKeyDownPaymentAmount(event: KeyboardEvent) {
        const invalidKeys = [ 'e', 'E', '+', '-', '=' ];
        const allowedKeys = [ 'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete' ];

        if (
            invalidKeys.includes(event.key) &&
            !allowedKeys.includes(event.key)
        ) {
            event.preventDefault();
        }
    }

    onHeightWidthBlur(field: 'height' | 'width') {
        const value = this.addOrderForm.get(field)?.value;

        if (value !== null && value !== undefined && value !== '') {
            this.addOrderForm.get(field)?.setValue(
                +this.roundHeightWidth(+value).toFixed(2),
                { emitEvent: false }
            );
        }
    }

    roundHeightWidth(value: number): number {
        return Math.ceil(value * 4) / 4;
    }

    async onSubmit() {
        if (this.addOrderForm.valid) {
            if (this.itemCount === 1) {
                this.ns.showError("Please Checkout the existing order");
                return;
            }
            let formData = this.addOrderForm.getRawValue();


            // let cdrFileUploadres = await this.fileUpload(this.uploadedFiles);
            let prizeDetail: any;

            let selectedProductObject = <any>this.products.find((product: any) => {
                return this.addOrderForm.get('selectedProduct')?.value == product._id;
            });


            const selectedQty = this.addOrderForm.get('selectedQty')?.value || 0;
            const costMultiplier = selectedQty / 1000;
            this.totalV = formData.totalPrice * costMultiplier;

            if (this.productGroupCategory === EProductGroupType.STICKER_PER_SQ_INCH) {
                if (selectedProductObject.mpp_IsheightWidth_bl) this.totalV = (formData.totalPrice * Number(costMultiplier)) * ((formData.width || 1) * (formData.height || 1));
                else this.totalV = formData.totalPrice * Number(costMultiplier);
            }

            if (this.productGroupCategory === EProductGroupType.GSM_ART_MIX_250) {
                if (selectedProductObject.mpp_IsheightWidth_bl) this.totalV = (formData.totalPrice * Number(costMultiplier)) * ((formData.width || 1) * (formData.height || 1));
                else this.totalV = formData.totalPrice * Number(costMultiplier);
            }

            if (this.productGroupCategory === EProductGroupType.VISITING_CARD || this.productGroupCategory === EProductGroupType.PREMIUM_VISITING_CARD) {
                let totalAmount = (formData.totalPrice * costMultiplier);

                if (formData.foil === 'Gold') totalAmount += (selectedProductObject.mpp_foil_golden_price_num * costMultiplier) || 0;
                if (formData.foil === 'Silver') totalAmount += (selectedProductObject.mpp_foil_silver_price_num * costMultiplier) || 0;

                if (formData.spotUv === 'Single Side') totalAmount += (selectedProductObject.mpp_spot_uv_single_price_num * costMultiplier) || 0;
                if (formData.spotUv === 'Both Side') totalAmount += (selectedProductObject.mpp_spot_uv_both_price_num * costMultiplier) || 0;

                this.totalV = totalAmount;
            }

            // if (this.productGroup === '250 GSM Art / Mix') {
            //     if (formData.squareAndRegular === 'Square') this.totalV = (selectedProductObject.mpp_square_inch_price_num * Number(selectedQty)) * (formData.width * formData.height);
            //     if (formData.squareAndRegular === 'Regular') this.totalV = selectedProductObject.mpp_productPrice_num * costMultiplier;
            // }

            if (this.productGroupCategory === EProductGroupType.SPECIAL_JOB) this.totalV = this.addOrderForm.get('price')?.value;

            // this.totalV = this.totalV;
            prizeDetail = {
                cost: this.totalV,
                quantity: selectedQty,
                total: this.totalV
            };
            // this.totalV = this.costV;

            // if (selectedProductObject.mpp_IsGstProduct_bl) {
            //     // const selectedQty = this.addOrderForm.get('selectedQty')?.value || 0;
            //     //
            //     // // Calculate cost based on quantity batches of 1000
            //     // const costMultiplier = selectedQty / 1000;
            //     // this.costV = selectedProductObject.mpp_productPrice_num * costMultiplier;
            //
            //     // GST calculation
            //     // this.gstV = this.costV * this.taxValue / 100;
            //     // this.totalV = this.costV + this.gstV;
            //     // console.log(this.totalV);
            //     // console.log(this.gstV);
            //
            //     prizeDetail = {
            //         cost: this.costV,
            //         quantity: selectedQty,
            //         total: this.costV
            //     };
            //     this.totalV = this.costV;
            // } else {
            //     // this.gstV = 0;
            //     this.totalV = this.costV;
            //     prizeDetail = {
            //         cost: this.costV,
            //         quantity: selectedQty,
            //         total:  this.costV
            //     };
            // }

            let price: number = 0;

            if (this.productGroupCategory === EProductGroupType.SPECIAL_JOB) {
                price = this.addOrderForm.get('price')?.value;
            } else if (this.productGroupCategory === EProductGroupType.VISITING_CARD || this.productGroupCategory === EProductGroupType.PREMIUM_VISITING_CARD) {
                // let totalAmount = formData.totalPrice;
                // if (formData.foil === 'Gold') totalAmount += (selectedProductObject.mpp_foil_golden_price_num || 0);
                // if (formData.foil === 'Silver') totalAmount += (selectedProductObject.mpp_foil_silver_price_num || 0);
                //
                // // if (formData.spotUv === true) totalAmount += (selectedProductObject.mpp_spot_uv_price_num || 0);
                // if (formData.spotUv === 'Single Side') totalAmount += (selectedProductObject.mpp_spot_uv_single_price_num * costMultiplier) || 0;
                // if (formData.spotUv === 'Both Side') totalAmount += (selectedProductObject.mpp_spot_uv_both_price_num * costMultiplier) || 0;
                // price = totalAmount;
                if (formData.selectedPrint === 'Single Side') price = (selectedProductObject.mpp_productPrice_singleSide_num ) || 0;
                if (formData.selectedPrint === 'Both Side') price = (selectedProductObject.mpp_productPrice_bothSide_num) || 0;

            } else {
                price = formData.totalPrice;
            }

            // else if (this.productGroup === '250 GSM Art / Mix') {
            //         if (formData.squareAndRegular === 'Square') price = (selectedProductObject.mpp_square_inch_price_num * 1000) * (formData.width * formData.height);
            //         if (formData.squareAndRegular === 'Regular') price = selectedProductObject.mpp_productPrice_num;
            //     }

            const orderForm = {
                product_objid: this.addOrderForm.get('selectedProduct')?.value,
                productGroup_objid: this.productGroupId, // product group id
                productGroup: this.productGroup,
                productGroupCategory: this.productGroupCategory,
                jobName: this.addOrderForm.get('jobName')?.value,
                width: this.addOrderForm.get('width')?.value,
                height: this.addOrderForm.get('height')?.value,
                printing_side: this.addOrderForm.get('selectedPrint')?.value,
                // squareAndRegular: this.addOrderForm.get('squareAndRegular')?.value,
                foil: formData.foil,
                spotUv: formData.spotUv,
                price: price,
                quantity: formData.selectedQty,
                totalPrice: this.totalV,
                user_objid: this.authService.gUser?._id,
                // cdrFiles_arr: cdrFileUploadres
            };
            let res = await this.addOrderService.post(orderForm);
            if (res) {
                this.priceDetails.push(
                    {
                        _id: res._id,
                        ...prizeDetail
                    }
                );
                this.ns.showSuccess(`Item added successfully to your cart`);
                this.eventCenterS.loadAddToCard.next(true);
                this.eventCenterS.loadAddToCardProducts.next(true);
                // this.resetForm();
            }
        } else {
            if (this.addOrderForm.invalid) {
                this.ns.showError(`Please fill details`);
            } else {
                this.ns.showError(`Something Went Wrong`);
            }
        }
    }

    getCalculatedPrice() {
        let totalPrice: number = this.addOrderForm.get('totalPrice')?.value || 0;
        let selectedProductObject = <any>this.products.find((product: any) => {
            return this.addOrderForm.get('selectedProduct')?.value == product._id;
        });

        if (this.productGroupCategory === EProductGroupType.VISITING_CARD || this.productGroupCategory === EProductGroupType.PREMIUM_VISITING_CARD) {
            const foil = this.addOrderForm.get('foil')?.value;
            const spotUv = this.addOrderForm.get('spotUv')?.value;
            if (spotUv) {
                if (spotUv === 'Single Side') totalPrice += selectedProductObject.mpp_spot_uv_single_price_num || 0;
                if (spotUv === 'Both Side') totalPrice += selectedProductObject.mpp_spot_uv_both_price_num || 0;
            }
            if (foil) {
                if (foil === 'Gold') totalPrice += selectedProductObject.mpp_foil_golden_price_num || 0;
                if (foil === 'Silver') totalPrice += selectedProductObject.mpp_foil_silver_price_num || 0;
            }
        }
        return totalPrice.toFixed(2);
    }
}


interface product {
    name: string;
    _id: string;
    mpp_IsGstProduct_bl: boolean;
    mpp_IsheightWidth_bl: boolean;
    mpp_productPrice_bothSide_num: number;
    mpp_productPrice_singleSide_num: number;
    mpp_productGroupImg_arr: Array<any>;
    mpp_description_str: string;
    mpp_foil_silver_price_num?: number;
    mpp_foil_golden_price_num?: number;
    mpp_spot_uv_single_price_num?: number;
    mpp_spot_uv_both_price_num?: number;
    mpp_halfBladePerPrice_num?: number;
    mpp_perforatedPerPrice_num?: number;
    mpp_creassingPerPrice_num?: number;
    mpp_diePunchingPerPrice_num?: number;
    mpp_foldingPerPrice_num?: number;
}

interface category {
    name: string;
    code: string;
}

interface size {
    name: string;
    code: string;
}

interface print {
    name: string;
    code: string;
}

interface foil {
    name: string;
    code: string;
}

interface spotUv {
    name: string;
    code: string;
}

interface qty {
    name: string;
    code: string;
}

interface UploadEvent {
    originalEvent: Event;
    files: File[];
}
